import Modal from 'react-bootstrap/Modal';
import './LegalNoticesModal.css';

interface ModernSlaveryModalProps {
  show: boolean;
  onHide: () => void;
}

function ModernSlaveryModal({ show, onHide }: ModernSlaveryModalProps) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      scrollable
      aria-labelledby="footer-modern-slavery-modal-title"
      contentClassName="v3-dialog"
    >
      <Modal.Header closeButton closeVariant="white">
        <Modal.Title id="footer-modern-slavery-modal-title">Modern Slavery</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className="legal-section">
          <h1 className="mb-3 Garamond">Modern Slavery and Human Trafficking Statement</h1>
          <p><strong>This statement is published pursuant to section 54 of the Modern Slavery Act 2015 (the MSA) and sets out the steps taken by aosphere Limited (aosphere) to ensure that modern slavery and human trafficking does not take place in its supply chains or in its own business for the financial year ending 31 December 2024.</strong></p><p>aosphere is committed to acting ethically and with integrity in all of its dealings and relationships and recognises the need for transparency and accountability. We are committed to implementing and enforcing effective systems and controls to ensure that modern slavery and human trafficking are not taking place in any part of our business or supply chain. </p>
        </section>

        <section className="legal-section">
          <h2 className="mb-3">About aosphere Human Trafficking Statement</h2>
          <p>aosphere is a leading provider of online legal services. We deliver high quality legal risk management products through an online platform for our subscribers, to help them operate more efficiently. aosphere is headquartered in London, UK and most of our staff are based in London.</p>
        </section>

        <section className="legal-section">
          <h2 className="mb-3">Policies and processes</h2>
          <p>aosphere sets high behavioural, ethical, and compliance standards and has a number of policies in place which help to mitigate the risks of modern slavery and trafficking both within its supply chain and own operations.</p>
          <p>Such policies include:</p>
          <ul>
            <li>Code of Conduct and Ethics</li>
            <li>Anti-Fraud, Bribery and Corruption Policy</li>
            <li>Whistleblowing Policy</li>
            <li>Supplier Code of Conduct</li>
            <li>Health and Safety Policy</li>
            <li>Anti-Harassment Anti-Sexual Harassment & Anti-Bullying Policy</li>
          </ul>
          <p>These policies are reviewed regularly and are available to all employees. </p>
        </section>
        <section className="legal-section">
          <h2 className="mb-3">Supply Chain</h2>
          <p>As an online legal content provider, our commercial supply chains are relatively simple and involve the provision of business and professional services. We do not consider that these relationships give rise to material risks in connection with modern slavery or human trafficking. aosphere&apos;s supply chains primarily comprise professional services, catering and hospitality services, facilities management and maintenance, information technology and courier services.</p>
          <p>aosphere does not tolerate forced labour either within its business or supply chain and expects its supply chain partners to share the same values.</p>
        </section>
        <section className="legal-section">
          <h2 className="mb-3">Due Diligence and Risk Assessment</h2>
          <p>aosphere manages risks in the supply chain by using reputable suppliers. In addition to this, in certain cases we have included specific contractual clauses in our agreements requiring compliance with applicable anti-slavery and human trafficking laws. We have established, long term relationships with several key suppliers. Where our product teams work with local counsel outside of the UK, we instruct leading reputable law firms in the relevant jurisdictions.</p>
          <p>We have provided helpful resources for staff, including links to the Global Slavery Index from Walk Free and the Corruption Perceptions Index, to assist in due diligence and identifying potential risks in the process of engaging new suppliers.</p>
        </section>
        <section className="legal-section border-0">
          <h2 className="mb-3">Training and Awareness</h2>
          <p>aosphere is committed to ensuring awareness of modern slavery and human trafficking amongst its management and employees. We have engaged a training provider and all employees will receive training on modern slavery and human trafficking through an online learning module.</p>

          <p>This statement is made in accordance with section 54(1) of the MSA and constitutes aosphere&apos;s modern slavery and human trafficking statement for the financial year ending 31 December 2024.</p>

          <p>We are committed to continuous improvement and will continue to further enhance our approach to supply chain due diligence.</p>

          <p>This statement has been approved by the board of directors of aosphere Limited on 15th May 2025. </p>

          <p className="Garamond">
            <span className="font18">Marc-Henri Chamay
              <br />
              CEO</span>
            <br />
            aosphere Limited
            <br />
            Date: 16th May 2025
          </p>
        </section>

      </Modal.Body>
    </Modal>
  );
}

export default ModernSlaveryModal;
